import { CoreStorageService } from '@core/infrastructure/storage/storage.service';
import { ProductPublicModels } from '@features/products/product';
import { ItxObservabilityCommands } from '@frontend/libs/itx-observability-core';

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class SastreService {
    // Necesitamos pasar explícitamente este parámetro porque en back no lo tienen
    //   ya que no se genera cookie WC_AUTH porque el usuario puede no haber pasado por cesta o checkout que es donde se genera
    public static getVisitorId(storageService: CoreStorageService): string {
        let visitorId: string;
        try {
            const analyticsId = storageService.getValue<string>('_gid') || storageService.getValue<string>('_ga');
            const chunks = analyticsId.split('.');
            // tomamos los dos últimos números separados por punto
            visitorId = `${chunks[chunks.length - 2]}.${chunks[chunks.length - 1]}`;
        } catch (e) {
            visitorId = null;
            ItxObservabilityCommands.sendObservabilityLog(`[Sastre] Google analytics ID not found ${e}`, 'SastreService getVisitorId');
            console.warn(`[Sastre] Google analytics ID not found ${e}`);
        }
        return visitorId;
    }

    public static getProductId(product: ProductPublicModels.PublicProduct): string {
        return String(product.status?.selectedColor?.catentryId || product.id);
    }
}
